// extracted by mini-css-extract-plugin
module.exports = {"question":"accordionItem_question__a8c5X","answer":"accordionItem_answer__xDHHR","border-bottom":"accordionItem_border-bottom__WDKE9","border":"accordionItem_border__wRRJx"};